var map = {
	"./DERMSTORE.png": 1609,
	"./RodanField.png": 1443,
	"./Shubham-Pandey-Resume.pdf": 8632,
	"./Yoox.png": 8307,
	"./bewakoof.png": 2337,
	"./nn.jpg": 3423,
	"./recruitee.png": 7806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7292;